import * as paths from '/00_global/scripts/paths';

/*=============================================
= START - React Routes
=============================================*/

// Definition of React Routes
// https://reacttraining.com/react-router/web/example/route-config

// path: the route of the component
// component: the component itself (here the PageTemplate component will render the correct page).
// exact: When true, will only match if the path matches the location.pathname exactly.

export const Routes = Object.entries(paths)
	.filter(([key]) => key.startsWith('PATH_'))
	.sort((a, b) => { // make sure that * is last
		if (a[1] === '*') return true;
		else if (b[1] === '*') return false;
		else return a[1].localeCompare(b[1]);
	})
	.map(([key, value]) => ({ path: value, exact: key != 'PATH_NOMATCH' }));

/*=============================================
= END - React Routes
=============================================*/
